export const cartOverviewInit = () => {
  const cartOverviewBoxes = document.querySelectorAll<HTMLElement>('.b-cart-overview');

  cartOverviewBoxes.forEach(overview => {
    const products = overview.querySelector<HTMLElement>('.b-cart-overview__products');
    const productsButton = overview.querySelector<HTMLElement>('.b-cart-overview__products-button');
    if(!products || !productsButton) return;

    productsButton.addEventListener('click', (e) => {
      e.preventDefault();
      products.classList.toggle('--opened');

      const titleWrapper = productsButton.querySelector<HTMLElement>('.link__title');
      if(titleWrapper) {
        const tempTitle = titleWrapper.innerText;
        titleWrapper.innerText = productsButton.dataset.secondTitle ?? titleWrapper.innerText;
        productsButton.dataset.secondTitle = tempTitle;
      }
    })
  })
}

cartOverviewInit();
